import http from '@/utils/http';

// // 搜索
// export const searchVenue = (params) => {
//     return http.request({
//         url: '/v1/ballsports/base/venue/search',
//         method: 'post',
//         data: params
//     })
// }

// 获取列表
export const getCompetitionLevel = (params) => {
    return http.request({
        url: '/v1/ballsports/base/competition_level/list',
        method: 'get',
        params: params
    })
}

// 更新
export const updateCompetitionLevel = (params) => {
    return http.request({
        url: "/v1/ballsports/base/competition_level/update",
        method: 'post',
        data: params,
    })
}